// extracted by mini-css-extract-plugin
export default {"information-boxes":"styles_information-boxes__5LFjk"};